import { 
    FETCH_BIDS_SUBMITTING, 
    FETCH_BIDS_SUCCESS,
    CREATE_RFQ_SUCCESS, 
    SET_NEXT_RFQ_VIEW,
    SET_PREVIOUS_RFQ_VIEW,
    CREATE_RFQ_SUBMITTING,
    GET_TRIPS_SUCCESS,
    CLEAR_RFQS,
    CLEAR_TRIPS,
    GET_RFQS_SUCCESS,
    GET_RFQ_TRIPS_SUCCESS,
    GETTING_RFQS,
    GET_RFQS_ERROR,
    UPLOAD_DOCUMENT_SUBMITTING,
    UPLOAD_DOCUMENT_SUCCESS,
    SET_RFQ_ACTIVE_VIEW,
    ADD_TRIP_ADDING,
    ADD_TRIP_SUBMITTING,
    ADD_TRIP_SUCCESS,
    SET_DOCUMENTS,
    DELETE_TRIP_SUCCESS,
    GET_TRIPS_LOADING,

    GET_RFQ_DETAIL_SUCCESS,

    FETCH_SEEKER_BIDS_SUCCESS,
    FETCH_SEEKER_BIDS_SUBMITTING,
    CLEAR_FETCH_SEEKER_BIDS,

    DOWNLOAD_RFQ_TEMPLATE_SUCCESS,
    DOWNLOAD_TRIPS_TEMPLATE_SUCCESS,
    DOWNLOAD_TRIPS_TEMPLATE_SUBMITTING,
    DOWNLOAD_RFQ_TEMPLATE_SUBMITTING,

    UPLOAD_TRIPS_SUBMITTING,
    UPLOAD_TRIPS_SUCCESS,
    UPLOAD_RFQ_SUBMITTING,
    UPLOAD_RFQ_SUCCESS,
    GET_QBR_SUCCESS,

    ALL_LOCATIONS_LIST,
    AUTO_SUGGEST_LOCATIONS_DATA,

    GET_ALL_SUBPLANTS_DATA,
    SAVE_NETWORK_DETAILS,
    DELETE_ADDED_TRIP_START,
    DELETE_ADDED_TRIP_END,
    GET_COURIER_TRIPS_SUCCESS,
    GET_COURIER_TRIPS_START,
    POST_COURIER_TRIPS_END,
    GET_SERVICE_CATEGORY_START,
    GET_SERVICE_CATEGORY_END,
    SAVE_SERVICE_CATEGORY,
    GET_TRANSPORTER_BID_COMMON_CHARGES_CLEAR,
    SAVE_TRANSPORTER_BID_COMMON_CHARGES,
    GET_TRANSPORTER_BID_COMMON_CHARGES_SUCCESS
} from 'Constants/actionConstants';
import { CLEAR_RFQ_DETAIL } from 'Constants/actionConstants';

const rfq = (state={
    activeView: 1,
    createdRFQ: null,
    rfqDetail: null,
    createRFQ: {
        dataSubmitting: false
    },
    trips:  {
        data:[],
        dataLoaded: false,
        addingTrip: false,
        dataSubmitting: false,
        trip: null,
        dataLoading: false,
        qbr: ""
    },
    rfqs: {
        data: null,
        gettingRfqs: false,
        activeCount: 0,
        biddingCount: 0,
        closePendingCount: 0,
        loiCount: 0,
        rfqApprovedCount:0,
        rfqApproverPendingCount:0,
        rfqApproverApproved:0,
        loi_contract_count: 0

    },
    documents: {
        data: [],
        dataSubmitting: false
    },
    tripBids: {
        bids: [],
        rules: [],
        pricingBasis: "",
        dataFetching: false
    },
    seekerBids: {
        data:null,
        dataLoading: false
    },
    downloadTemplates: {
        rfq: '',
        trips: '',
        dataSubmitting: false
    },
    uploadTemplates: {
        dataSubmitting: false
    },
    autoSuggestLocations: [],
    allSubPlants: [],
    networkData: [],
    rfqTripRecords: {
        data: [],
        rfqDetails: {},
        gettingRfqs: false,
    },
    deleteAddedTrip: false,
    courierTrips: {
        data: [],
        dataLoading: false,
        otherCharges: [],
    },
    serviceCategory: {
        data: [],
        dataLoading: false
    },
    transporterBidCCharges: {
        data: [],
        dataLoading: false
    }
}, action)=> {
    let newState;
    if(action.type === CREATE_RFQ_SUCCESS) {
        newState = {
            ...state,
            createdRFQ: action.rfq || state.createRFQ,
            createRFQ: {
                dataSubmitting: false
            }
        };
    }
    else if(action.type === ADD_TRIP_ADDING) {
        newState = {...state};
        newState.trips.addingTrip = action.addingTrip;
        newState.trips.trip = action.trip;
        if (action.saveAndKeepAdding) {
            const new_obj = newState.trips.data[newState.trips.data.length - 1];
            new_obj.id = undefined;
            newState.trips.trip = {...new_obj};
        }
    }
    else if(action.type === ADD_TRIP_SUBMITTING) {
        newState = {...state};
        newState.trips.dataSubmitting = true;
    }
    else if(action.type === ADD_TRIP_SUCCESS) {
        newState = {...state};
        newState.trips.dataSubmitting = false;
    }
    else if(action.type === DELETE_TRIP_SUCCESS) {
        newState = {...state};
        // newState.trips.dataSubmitting = false;
        const tripIndex = newState.trips.data.findIndex((trip)=> (trip.id === action.tripId));
        newState.trips.data.splice(tripIndex, 1);
    }
    else if(action.type === SET_RFQ_ACTIVE_VIEW) {
        newState = {
            ...state,
            activeView: action.view
        };
    }
    else if(action.type === SET_NEXT_RFQ_VIEW) {
        newState = {
            ...state,
            activeView: state.activeView + 1
        };
    }
    else if(action.type === SET_PREVIOUS_RFQ_VIEW) {
        newState = {
            ...state,
            activeView: state.activeView - 1
        };
    }
    else if(action.type === CREATE_RFQ_SUBMITTING) {
        newState = {
            ...state,
            createRFQ: {
                dataSubmitting: true
            }
        };
    }
    else if(action.type === GET_TRIPS_LOADING) {
        newState = {...state}
        newState.trips.dataLoading = true;
    }
    else if(action.type === CLEAR_TRIPS) {
        newState = {...state}
        newState.trips.data = [];
        newState.trips.dataLoading = true;

    }
    else if(action.type === GET_TRIPS_SUCCESS) {
        newState = {...state}
        newState.trips.dataLoading = false;
        newState.trips.data = action.trips;
        newState.trips.tripsCount = action.tripsCount;
        newState.trips.otherCharges = action.otherCharges;
        newState.trips.slabList = action.slabList || [];
        newState.trips.additionalZoneList = action.additionalZoneList || [];
        newState.trips.fromZones = action.fromZones || [],
        newState.trips.toZones = action.toZones || [],
        newState.trips.tZones = action.tZones || [],
        newState.trips.plantNames = action.plantNames || [],
        newState.trips.materials = action.materials || [],
        newState.trips.distNames = action.distNames || [],
        newState.trips.totalValueVisibilityOnProvider = action.totalValueVisibilityOnProvider || false,
        newState.trips.totalValueVisibilityOfL1OnProvider = action.totalValueVisibilityOfL1OnProvider || false,
        newState.trips.visibilityOfLotRankingForProvider = action.visibilityOfLotRankingForProvider || false,
        newState.trips.chatBoxEnable = action.chatBoxEnable || false,
        newState.trips.maxCountToWithdrawBid = action.maxCountToWithdrawBid || '',
        newState.trips.totalBidExtension = action.totalBidExtension || 0,
        newState.trips.allowTransporterToAddCostHeadDuringBidding = action.allowTransporterToAddCostHeadDuringBidding || false,
        newState.trips.transporterBiddedCount = action.transporterBiddedCount || 0;
    } 
    else if(action.type === GET_RFQS_ERROR) {
        newState = {...state};
        newState.rfqs = {
          data: [],
          gettingRfqs: false
        }
    } 
    else if(action.type === GETTING_RFQS) {
        newState = {...state};
        newState.rfqs = {
            ...newState.rfqs,
            gettingRfqs: true
        }
    } 
    else if(action.type === GET_RFQS_SUCCESS) {
        newState = {...state};
        newState.rfqs = {
            ...action.data,
            data: action.data.list,
            gettingRfqs: false
        }
    } 
    else if(action.type ===  GET_RFQ_TRIPS_SUCCESS) {
        newState = {...state};
        newState.rfqTripRecords = {
            data: action.data.list,
            rfqDetails: action.data.rfqDetails,
            gettingRfqs: false
        }
    }
    else if(action.type === CLEAR_RFQS) {
        newState = {...state};
        newState.rfqs = {
          data: null,
          gettingRfqs: false
        }
    } 
    else if(action.type === UPLOAD_DOCUMENT_SUBMITTING) {
        newState = {...state};
        newState.documents.dataSubmitting = true;
    } 
    else if(action.type === UPLOAD_DOCUMENT_SUCCESS) {
        newState = {...state};
        newState.createdRFQ.addDocument(action.document);
        newState.documents.dataSubmitting = !newState.documents.dataSubmitting;
    } 
    else if(action.type === SET_DOCUMENTS) {
        newState = {...state};
        newState.documents = {
          data: action.documents,
          dataSubmitting: false
        }
    } 
    else if(action.type === GET_RFQ_DETAIL_SUCCESS) {
        newState = {...state};
        newState.createdRFQ = action.rfq;
        newState.eventDetails = action.eventDetails || {};
    }  
    else if(action.type === CLEAR_RFQ_DETAIL) {
        newState = {...state};
        newState.createdRFQ = null;
        newState.seekerBids.data = null;
        newState.trips.data = []
    }
    else if(action.type === FETCH_BIDS_SUCCESS) {
        newState = { ...state };
        newState.tripBids = {
            ...action.transFormedData,
            dataFetching: false
        }
    } 
    else if(action.type === FETCH_BIDS_SUBMITTING) {
        newState = { ...state };
        newState.tripBids = {
            ...newState.tripBids,
            dataFetching: true
        }
    } 
    else if(action.type === FETCH_SEEKER_BIDS_SUBMITTING) {
        newState = { ...state };
        newState.seekerBids = {
            ...newState.seekerBids,
            dataLoading: true,
        }
    } 
    else if(action.type === CLEAR_FETCH_SEEKER_BIDS) {
        newState = { ...state };
        newState.seekerBids = {
            ...newState.seekerBids,
            trips: [],
            dataLoading: true
        }
    } 
    else if(action.type === FETCH_SEEKER_BIDS_SUCCESS) {
        newState = { ...state };
        newState.seekerBids = {
            ...newState.seekerBids,
            dataLoading: false,
            data: action.rfq,
            trips: action.rfq.trips || [],
            tripsCount: action.tripsCount,
            slabList: action.slabList || [],
            maxTransportersCountRFQ: action.maxTransportersCountRFQ || 0,
            fromZones: action.fromZones || [],
            toZones: action.toZones || [],
            bided_transporter_name: action.bided_transporter_name || [],
            chat_menu: action.chat_menu
        }
    }
    else if (action.type === ALL_LOCATIONS_LIST) {
        newState = { ...state };
        newState.allLocations = action.data;
    }
    else if (action.type === AUTO_SUGGEST_LOCATIONS_DATA) {
        newState = { ...state };
        newState.autoSuggestLocations = action.data;
    }
    else if (action.type === GET_ALL_SUBPLANTS_DATA) {
        newState = {...state};
        newState.allSubPlants = action.data.subplant_name || [];
    }

    /* DOWNLOAD TEMPLATES.......*/
    else if(action.type === DOWNLOAD_RFQ_TEMPLATE_SUBMITTING) {
        newState = { ...state };
        newState.downloadTemplates.dataSubmitting = true;
    }
    else if(action.type === DOWNLOAD_RFQ_TEMPLATE_SUCCESS) {
        newState = { ...state };
        newState.downloadTemplates.rfq = action.url;
        newState.downloadTemplates.dataSubmitting = false;
    }
    else if(action.type === DOWNLOAD_TRIPS_TEMPLATE_SUBMITTING) {
        newState = { ...state };
        newState.downloadTemplates.dataSubmitting = true;
    }
    else if(action.type === DOWNLOAD_TRIPS_TEMPLATE_SUCCESS) {
        newState = { ...state };
        newState.downloadTemplates.trips = action.url;
        newState.downloadTemplates.dataSubmitting = false;
    }
    /* DOWNLOAD TEMPLATES END..............*/


    /* UPLOAD TEMPLATES.......*/
    else if(action.type === UPLOAD_TRIPS_SUBMITTING) {
        newState = { ...state };
        newState.uploadTemplates.dataSubmitting = true;
    }
    else if(action.type === UPLOAD_TRIPS_SUCCESS) {
        newState = { ...state };
        newState.uploadTemplates.dataSubmitting = false;
    }
    else if(action.type === UPLOAD_RFQ_SUBMITTING) {
        newState = { ...state };
        newState.uploadTemplates.dataSubmitting = true;
    }
    else if(action.type === UPLOAD_RFQ_SUCCESS) {
        newState = { ...state };
        newState.uploadTemplates.dataSubmitting = false;
    }
    else if(action.type === GET_QBR_SUCCESS) {
        newState = { ...state };
        newState.trips.qbr = action.qbr;
    }
    else if(action.type === SAVE_NETWORK_DETAILS) {
        newState = {...state};
        newState.networkData = action.data;
    } 
    else if(action.type === DELETE_ADDED_TRIP_START) {
        newState = {...state};
        newState.deleteAddedTrip = true;
    }
    else if(action.type === DELETE_ADDED_TRIP_END) {
        newState = {...state};
        newState.deleteAddedTrip = false;
    }
    else if(action.type === GET_COURIER_TRIPS_SUCCESS) {
        newState = {...state};
        newState.courierTrips.data = action.trips;
        newState.courierTrips.otherCharges = action.otherCharges;
        newState.courierTrips.dataLoading = false;
        newState.courierTrips.tripsCount = action.tripsCount;
        newState.courierTrips.rowZones = action.rowZones || [];
        newState.courierTrips.additionalZones = action.additionalZones || [];
        newState.courierTrips.colZones = action.colZones || [];
    }
    else if(action.type === GET_COURIER_TRIPS_START) {
        newState = {...state};
        newState.courierTrips.dataLoading = true;
    }
    else if(action.type === POST_COURIER_TRIPS_END) {
        newState = {...state};
        newState.courierTrips.dataLoading = false;
    }
    else if(action.type === GET_SERVICE_CATEGORY_START) {
        newState = {...state};
        newState.serviceCategory.dataLoading = true;
    }
    else if(action.type === SAVE_SERVICE_CATEGORY) {
        newState = {...state};
        newState.serviceCategory.dataLoading = false;
        newState.serviceCategory.data = action.data;
    }
    else if(action.type === GET_SERVICE_CATEGORY_START) {
        newState = {...state};
        newState.serviceCategory.dataLoading = false;
    }
    else if(action.type === GET_TRANSPORTER_BID_COMMON_CHARGES_CLEAR) {
        newState = {...state};
        newState.transporterBidCCharges.dataLoading = true;
        newState.transporterBidCCharges.data = [];
    }
    else if(action.type === SAVE_TRANSPORTER_BID_COMMON_CHARGES) {
        newState = {...state};
        newState.transporterBidCCharges.data = action.data;
        newState.transporterBidCCharges.dataLoading = false;
    }
    else if(action.type === GET_TRANSPORTER_BID_COMMON_CHARGES_SUCCESS) {
        newState = {...state};
        newState.transporterBidCCharges.dataLoading = false;
    }
    /* UPLOAD TEMPLATES END..............*/

    return newState || state;
}

export default rfq;